function makeGetDefaultTheme(createTheme) {
    let defaultTheme;
    return function getDefaultTheme() {
        if (!defaultTheme) {
            defaultTheme = createTheme();
        }
        return defaultTheme;
    };
}
export default makeGetDefaultTheme;
